import { Badge } from "@/components/ui";

type ByomRuntime = "ollama" | "vllm" | "lmstudio" | "localai" | "other";
type ProviderType = "builtin_openai" | "byom_openai_compatible";

interface ProviderStatusBadgeProps {
  provider: ProviderType;
  runtime?: ByomRuntime;
  lastTestSuccess?: boolean;
  lastTestedAt?: number;
}

const RUNTIME_LABELS: Record<ByomRuntime, string> = {
  ollama: "Ollama",
  vllm: "vLLM",
  lmstudio: "LM Studio",
  localai: "LocalAI",
  other: "Custom",
};

function getIndicatorColor(lastTestSuccess?: boolean): {
  bg: string;
  text: string;
  label: string;
} {
  if (lastTestSuccess === true) {
    return { bg: "rgba(34,197,94,0.15)", text: "#22c55e", label: "Active" };
  }
  if (lastTestSuccess === false) {
    return { bg: "rgba(239,68,68,0.15)", text: "#ef4444", label: "Failed" };
  }
  return {
    bg: "rgba(161,161,166,0.15)",
    text: "#a1a1a6",
    label: "Not tested",
  };
}

export function ProviderStatusBadge({
  provider,
  runtime,
  lastTestSuccess,
}: ProviderStatusBadgeProps) {
  if (provider === "builtin_openai") {
    return (
      <div className="flex items-center gap-2">
        <Badge color={{ bg: "rgba(34,197,94,0.15)", text: "#22c55e" }}>
          Active
        </Badge>
        <span className="text-[13px] text-secondary">Built-in AI (OpenAI)</span>
      </div>
    );
  }

  const runtimeLabel = runtime ? RUNTIME_LABELS[runtime] : "Custom";
  const indicator = getIndicatorColor(lastTestSuccess);

  return (
    <div className="flex items-center gap-2">
      <Badge color={{ bg: indicator.bg, text: indicator.text }}>
        {indicator.label}
      </Badge>
      <span className="text-[13px] text-secondary">
        Custom Model ({runtimeLabel})
      </span>
    </div>
  );
}
